<div class="form-horizontal mt-3">
  <div class="row align-items-center pb-2 d-flex justify-content-between">
    <div class="d-none d-sm-block col-sm-2">
      <small class="text-muted"
        >{{ "quantity" | translate | titlecase }}:
        {{ model.envelopeObserver?.length }}
      </small>
    </div>
    <div
      class="col-sm-10 d-flex flex-md-row-reverse align-items-center justify-content-end justify-content-md-start justify-content-sm-end toolbar"
    >
      <div
        class="d-flex flex-md-row-reverse align-items-center"
        *ngIf="model.envelopeObserver.length > 0"
      >
        <cdx-toolbar-search
          (onTyping)="onSearch($event)"
          [value]="searchText"
          [placeholder]="'search' | translate | titlecase"
          [maxlength]="255"
          [debounceTime]="600"
        >
        </cdx-toolbar-search>
        <div class="pl-3 d-flex ml-auto ml-md-0">
          <button
            class="cdx-button cdx-button--icon cdx-button--lg mr-1"
            (click)="showConfirmationDelete(confirmDeleteModal)"
            [hidden]="!anyCheckedElement()"
            ngbTooltip="{{
              'envelope.observer.tooltip.removeObserver' | translate
            }}"
          >
            <fa-icon
              class="fa-fw cdx-button__icon"
              [icon]="['far', 'minus-circle']"
            ></fa-icon>
          </button>
          <button
            class="cdx-button cdx-button--icon cdx-button--lg"
            (click)="showAddObserverModal(modalAddObserver)"
            ngbTooltip="{{
              'envelope.observer.tooltip.addObserver' | translate
            }}"
          >
            <fa-icon
              class="fa-fw cdx-button__icon"
              [icon]="['far', 'plus-circle']"
            ></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="table-responsive table-box table-hover" *ngIf="model.envelopeObserver.length > 0; else blankSlateTable">
      <ng-container>
        <table class="table">
          <thead>
            <tr>
              <th
                scope="col"
                width="40"
                class="text-center selection-column"
                (click)="onCheckboxAll(!checkboxAllElements)"
                tabindex="0"
                (keyup.enter)="onCheckboxAll(!checkboxAllElements)"
              >
              <div class="d-flex justify-content-left">
                <fa-icon
                  class="fa-lg"
                  [icon]="['fal', 'square']"
                  *ngIf="!anyCheckedElement()"
                ></fa-icon>
                <fa-icon
                  class="fa-lg"
                  [icon]="['fas', 'minus-square']"
                  *ngIf="anyCheckedElement() && !checkboxAllElements"
                ></fa-icon>
                <fa-icon
                  class="fa-lg"
                  [icon]="['fas', 'check-square']"
                  *ngIf="checkboxAllElements"
                ></fa-icon>
              </div>
              </th>
              <th scope="col" class="text-left">
                {{ "name" | translate | titlecase }}
              </th>
              <th scope="col" class="text-left">
                {{ "mail" | translate | titlecase }}
              </th>
              <th scope="col" class="text-left" *ngIf="!hiddenPhoneColumn">
                {{ "telephone" | translate | titlecase }}
              </th>
              <th scope="col" class="text-left">
                {{ "envelope.observer.whenNotified" | translate }}
              </th>
              <th
                scope="col"
                class="text-left text-send-completed-envelope-toggle"
              >
                {{
                  "envelope.observer.titleSendCompletedEnvelope"
                    | translate
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let observer of model.envelopeObserver;
                index as i;
                trackBy: trackById
              "
              [ngClass]="{ 'row-active': observer.checked }"
            >
              <td width="40" class="selection-column">
                <div class="d-flex justify-content-left">
                  <span
                    class="cursor-pointer"
                    (click)="onCheckbox(!observer.checked, observer)"
                    tabindex="0"
                    (keyup.enter)="onCheckbox(!observer.checked, observer)"
                  >
                    <fa-icon
                      class="fa-lg"
                      [icon]="[(observer.checked ? 'fas' : 'fal'), (observer.checked ? 'check-square' : 'square')]"
                    ></fa-icon>
                  </span>
                </div>
              </td>
              <td class="text-truncate text-left">
                {{ observer.name }}
              </td>
              <td class="text-truncate text-left">
                {{ observer.mail | mailObfuscate }}
              </td>
              <td class="text-truncate text-left" *ngIf="!hiddenPhoneColumn">
                {{ observer.phoneNumber | phoneObfuscate }}
              </td>
              <td class="dropdownWhenNotified">
                <cdx-dropdown
                  [options]="dropdownWhenNotified"
                  [selectedItem]="getSelectedDropdownItem(observer)"
                  maxWidthButton="280"
                  maxWidthOptions="280"
                  (selectedItemChange)="
                    onDropdownSendEndEnvelope($event, observer)
                  "
                ></cdx-dropdown>
              </td>
              <td class="text-truncate text-left">
                <span
                  class="d-flex ml-auto text-send-completed-envelope-toggle"
                >
                  <cdx-toggle-switch
                    class="mr-1"
                    [toggledOn]="observer.sendCopyFinishedEnvelope"
                    (toggle)="onToggle($event, observer)"
                  ></cdx-toggle-switch>
                  {{
                    "envelope.observer.sendCompletedEnvelopeToggle" | translate
                  }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
  </div>
</div>
<ng-template #blankSlateSearchTemplate>
  <ng-container>
    <cdx-blankslate
      [options]="blankSlateSearch"
      (buttonClick)="onBlankSlateSearchClick($event)"
    >
      {{ "envelope.observer.blankSlateSearchText" | translate }}</cdx-blankslate
    >
  </ng-container>
</ng-template>
<ng-template #blankSlateTable>
  <div class="p-2 table__container">
    <ng-container *ngIf="searchText === ''; else blankSlateSearchTemplate">
      <cdx-blankslate
        [options]="blankSlate"
        (buttonClick)="showAddObserverModal(modalAddObserver)"
      >
        <span [innerHTML]="'envelope.observer.blankSlateText' | translate"></span>
      </cdx-blankslate>
    </ng-container>
  </div>
</ng-template>

<ng-template #modalAddObserver>
  <app-participant-modal
    (closeModalClick)="closeModalClick()"
    (submitModalClick)="submitAddModalClick($event)"
    [participantTypeInput]="participantType.Observer"
    [enableEditContact]="true"
  ></app-participant-modal>
</ng-template>

<ng-template #confirmDeleteModal>
  <app-confirm-modal
    [HeaderText]="
      'envelope.observer.confirm-disassociate-delete-modal.headerText'
    "
    [MessageText]="
      'envelope.observer.confirm-disassociate-delete-modal.messageText'
    "
    (closeModalClick)="confirmModalClose()"
    (confirmModalClick)="confirmModalYesClick()"
    [ButtonConfirmText]="'disassociateModalActions.remove'"
    [ButtonCancelText]="'disassociateModalActions.cancel'"
    [IsApprovalConfirm]="false"
    [modalIntentType]="modalIntentType.DANGER"
  >
  </app-confirm-modal>
</ng-template>